import { leadInfo, setSelectedLocation } from '../../utils/variables';
import { updateLeadPortal } from '../../services/digitsCodeService';

export function selectLocation(id) {
    removeAllSelectedLocation();

    setSelectedLocation(id);

    document
        .querySelector(
            `.location[data-location-id="${CSS.escape(id)}"]`
        )
        .classList.add('is-selected');

    document
        .querySelector('.locationContinue__btn')
        .classList.remove('disabled');

    // Persist the chosen location to the lead right away. If the patient
    // abandons the flow after this point, the lead still reflects the
    // location they selected rather than a default. Use the widget-authorized
    // endpoint (api/widget/leads/{text_id}) — the dashboard leads/{id} update
    // is not permitted for the widget token (403).
    if (leadInfo?.text_id) {
        updateLeadPortal(leadInfo.text_id, { location_id: id }).catch(() => {});
    }
}

export function removeAllSelectedLocation() {
    setSelectedLocation('');

    document
        .querySelectorAll('.location')
        .forEach((i) => i.classList.remove('is-selected'));

    document.querySelector('.locationContinue__btn').classList.add('disabled');
}
